// import Swiper from 'swiper/bundle';
import Swiper, { Parallax } from 'swiper';
import gsap from 'gsap';

import { each } from 'lodash'
export default class Creative {

    constructor() {
        this.carousel = {
            element: document.querySelector('.carousel[data-carousel="creative"]'),
        }

        this.timeline = {
            element: document.querySelector('[data-timeline]'),
            events: document.querySelectorAll('[data-timeline] ul.timeline--events li'),
            years: document.querySelectorAll('[data-timeline] ul.timeline--years li'),
        }

        this.createCarousel(this.carousel.element); // Init Carousel
    }

    createCarousel = (target) => {
        // this.navigationLocked = false;
        // this.transitionDisabled = false;
        // this.frameId;

        this.object = new Swiper(target, {
            // modules: [Parallax],
            speed: 600,
            slidesPerView: 1.25,
            spaceBetween: 20,
            centeredSlides: true,
            freeMode: {
                enabled: true,
                sticky: true,
                momentumBounce: false,
            },
            mousewheel: {
                sensitivity: 2.5,
            },
            // allowTouchMove: true, // no touch swiping
            navigation: {
                nextEl: "[data-next]",
                prevEl: "[data-prev]",
            },
            // parallax: true, // text parallax
        });

        each(this.timeline.events, (entry) => {
            entry.addEventListener('click', (event) => {
                var clickedYear = event.target.getAttribute('data-slide-index')

                this.object.slideTo(clickedYear, 1000, true)
            })
        })

        // On 'Init'
        // this.object.on('init', (carousel) => {
        //     const { slides, activeIndex } = carousel;
        //     const current = slides[activeIndex];
        //     // Set next title on Init
        //    console.log(current)
        // })

        this.object.on('transitionEnd', (carousel) => {
            const { slides, activeIndex } = this.object;

            var currentYear = slides[activeIndex].getAttribute('data-year');

            each(this.timeline.events, (entry) => {
                entry.classList.remove('active')
            })
            this.timeline.element.querySelector('.timeline--events [data-year="'+currentYear+'"]').classList.add('active')

            each(this.timeline.years, (entry) => {
                entry.classList.remove('active')
            })
            this.timeline.element.querySelector('.timeline--years [data-year="'+currentYear+'"]').classList.add('active')
        });

        // // On 'Resize'
        // this.object.on('resize', (carousel) => {
        //     const { slides, activeIndex } = carousel;
        //     this.disableTransitions(target); // disable initial transition
        //     // trigger the transitionEnd event once during initialization
        //     carousel.emit('transitionEnd');
        // })

        // // On 'Destroy'
        // this.object.on('destroy', (carousel) => {
        //     this.destroy(carousel);
        // })

        // this.object.on('transitionStart', (carousel) => {
        //     // console.log({carousel});
        //     const { slides, previousIndex, activeIndex } = carousel;

        //     const currentSlide = slides[activeIndex] // Current Slide
        //     const currentImage = currentSlide.querySelector('img'); // Current Image

        //     const previousSlide = slides[previousIndex] // Previous Slide
        //     const previousImageContainer = previousSlide.querySelector('[data-milestone-image]') // Image Container
        //     const previousImage = previousSlide.querySelector('img'); // Previous Image

        //     const direction = activeIndex - previousIndex;

        //     if (!this.transitionDisabled) { this.navigationLocked = true; } // lock navigation buttons

        //     previousImageContainer.transform('scale(.6)');
        //     previousImage.transition(1000).transform('scale(1.2)'); // image scaling parallax
        //     previousImage.transition(1000).transform('scale(1.2)'); // image scaling parallax

        //     previousSlide
        //         .querySelector('.slider-title-text')
        //         .transition(1000)
        //         .css('color', 'rgba(255,255,255,0)'); // title text transparency animation

        //     previousSlide
        //         .querySelector('.slider-description-text')
        //         .transition(1000)
        //         // .css('color', 'rgba(255,255,255,0)');// description text transparency animation

        //     previousSlide
        //         .querySelector('.content')
        //         .transition(1000)
        //         // .css('color', 'rgba(255,255,255,0)');// description text transparency animation


        //     previousImage.transitionEnd(() => {
        //         currentImage
        //             .transition(1300)
        //             .transform('translate3d(0, 0, 0) scale(1.2)'); // image shift parallax
        //         previousImage
        //             .transition(1300)
        //             .transform(`translate3d(${60 * direction}%, 0, 0)  scale(1.2)`);
        //     });
        // });

        // this.object.on('transitionEnd', (swiper) => {
        //     const { slides, activeIndex } = swiper;
        //     const $activeSlide = slides[activeIndex];
        //     const $activeImage = $activeSlide.querySelector('img');

        //     $activeSlide.querySelector('[data-milestone-image]').transform('scale(.9,.8)');
        //     $activeImage.transition(1000).transform('scale(1,1.2)');

        //     $activeSlide
        //         .querySelector('.slider-title-text')
        //         .transition(1000)
        //         .css('color', 'rgba(255,255,255,1)');

        //     $activeSlide
        //         .querySelector('.slider-description-text')
        //         .transition(1000)
        //         .css('color', 'rgba(255,255,255,1)');

        //     $activeSlide
        //         .querySelector('.content')
        //         .transition(1000)
        //         .css('color', 'rgba(255,255,255,1)');

        //     $activeImage.transitionEnd(() => {
        //         this.navigationLocked = false;
        //     });
        //     // First and last, disable button
        //     if (activeIndex === 0) {
        //         target
        //             .querySelector('.slider-button-prev')
        //             .classList.add('slider-button-disabled');
        //     } else {
        //         target
        //             .querySelector('.slider-button-prev')
        //             .classList.remove('slider-button-disabled');
        //     }

        //     if (activeIndex === slides.length - 1) {
        //         target
        //             .querySelector('.slider-button-next')
        //             .classList.add('slider-button-disabled');
        //     } else {
        //         target
        //             .querySelector('.slider-button-next')
        //             .classList.remove('slider-button-disabled');
        //     }
        // })



        // // On Next Transition Ends
        // this.object.on('slideChange', () => {
        //     var hasNext = (this.object.activeIndex + 1) < this.object.slides.length
        //     var hasPrev = this.object.activeIndex != 0
        //     console.log(hasPrev)
        //     if (hasNext) {
        //         this.nextTitle = this.object.slides[this.object.activeIndex + 1].dataset.title
        //         // Set Next Slide Preview (on Change)   
        //         gsap.to(this.carousel.nextArrow, {
        //             duration: 1.5,
        //             onComplete: () => {
        //                 this.carousel.nextArrow.querySelector('span').innerHTML = this.nextTitle
        //             }
        //         });
        //     }
        //     if (hasPrev) {
        //         this.prevDate = this.object.slides[this.object.activeIndex - 1].dataset.date
        //         // Set Next Slide Preview (on Change)    
        //         this.carousel.prevArrow.querySelector('span').innerHTML = this.prevDate;
        //     }

        // });

        // this.object.on('slideChangeTransitionStart', () => {
        //     this.carousel.element.querySelector('[data-next-arrow]').classList.add('hidden-effect');
        //     this.carousel.element.querySelector('[data-prev-arrow]').classList.add('hidden-effect');
        // });
        // this.object.on('slideChangeTransitionEnd', () => {
        //     this.carousel.element.querySelector('[data-next-arrow]').classList.remove('hidden-effect');
        //     this.carousel.element.querySelector('[data-prev-arrow]').classList.remove('hidden-effect');
        // });


        return this.object;
    }

    disableTransitions = (target) => {
        target.classList.add('slider-no-transition');
        this.transitionDisabled = true;

        cancelAnimationFrame(this.frameId);
        this.frameId = requestAnimationFrame(() => {
            target.classList.remove('slider-no-transition');
            this.transitionDisabled = false;
            this.navigationLocked = false;
        });
    };

    initNavigation = (carousel) => {
        // Use lock to control the button locking time without using the button component that comes with it
        target.querySelector('.slider-button-next').on('click', () => {
            if (!this.navigationLocked) {
                carousel.slideNext();
            }
        });

        target.querySelector('.slider-button-prev').on('click', () => {
            if (!this.navigationLocked) {
                carousel.slidePrev();
            }
        });
    };

    destroy = (carousel) => {
        target
            .querySelector('.slider-button-next, .slider-button-prev')
            .off('click');
    };
}